import { useBusinessInfo, useUserInfoQuery } from '~/lib/Queries';

const useIsAssistantEnabled = () =>
{
    const { data: userData } = useUserInfoQuery();
    const { data } = useBusinessInfo();

    return !!userData?.assistant &&
        !data?.hipaa &&
        !!data?.permissions?.isFullAccess;
}

export default useIsAssistantEnabled;
